<template>
  <section v-show="refError?.statusCode === 404">
    <div>
      <img
        src="data:image/png;base64,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"
      />
    </div>
    <h1>페이지를 찾지 못했어요</h1>
    <p>
      주소가 다르거나 페이지의 삭제로 인해 찾을 수 없어요.<br />페이지의 주소가
      정확한지 확인해 주세요.
    </p>
    <a href="https://oe-app.com/">오이 홈으로 이동</a>
  </section>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
const props = defineProps({ error: Object as () => NuxtError });
const refError = ref(props.error);
</script>

<style scoped>
body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  transform: translateY(-40px);
}
img {
  width: 100%;
  height: 100%;
}
div {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  border: 1px solid #e5e5ec;
  margin-bottom: 24px;
}
h1 {
  text-align: center;
  font-size: 24px;
  line-height: 34px;
  margin: 0;
  margin-bottom: 8px;
  color: #31353d;
}
p {
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  margin-bottom: 24px;
  color: #828894;
}
a {
  background: none;
  border: 0;
  color: #00b158;
  cursor: pointer;
  text-decoration: none;
}
</style>
